import { useState, useEffect } from "react";
import Slider from "react-slick";
import Link from "next/link";
import Image from "next/image";
import DefaulThumbnail from '../../../../public/images/we-decide-og.png';
import { NextArrow, PrevArrow } from "../../ArrowCarousel";
import { ConvertDateToTimeSince } from "../../../helpers/util";
import styles from "../../../styles/candidate/parts/CandidateCarousel.module.scss";

const CandidateCarousel = ({ items, isFeedLoading }) => {
  const [hasError, setHasError] = useState(null);

  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  useEffect(() => {
    setHasError(null);
  }, [items]);

  const Slides = () => {
    return items.map((item, index) => item && item.title ? (
        <div key={`slide-${index}`} className={styles.slidesWrapper}>
          <Link href={item.link} passHref>
            <a target="_blank">
              <div className={styles.thumbnailContainer}>
                { (hasError || []).findIndex(x => x === index) === -1
                  ? <Image
                      className={styles.thumbnail}
                      src={item.thumbnail}
                      onError={() => {
                        setHasError([...(hasError || []), index]);
                      }}
                      alt={item.title}
                      layout="responsive"
                      width={200}
                      height={200}
                    />
                  : <Image
                    loader={loader}
                    className={styles.thumbnail}
                    src={DefaulThumbnail}
                    alt={item.title}
                    layout="responsive"
                    width={200}
                    height={200}
                  />
                }
                
              </div>
              <div className={styles.textContainer}>
                <h3 className={styles.title}>{item.title}</h3>
                <p className={styles.description}>{ConvertDateToTimeSince(item.dateTime) || ''}</p>
              </div>
            </a>
          </Link>
        </div>
      ) : <div />)
  }

  const settings = {
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    lazyload: true,
    adaptiveHeight: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  return (
    <div className={styles.candidateCarousel}>
      {
        !isFeedLoading
          ? <Slider {...settings}>{Slides()}</Slider>
          : <div className={styles.feedLoading}>
              <p>Loading...</p>
            </div>
      }
    </div>
  )
};

export default CandidateCarousel;
